function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "a824d77b-7532-4eaa-a069-8afb933056db",
  "data-name": "Fill-6",
  d: "M24.85,12.88a1,1,0,1,0-1,1.66,7.57,7.57,0,1,1-7.74,0,1,1,0,0,0-1-1.66,9.5,9.5,0,1,0,10,.17ZM20,9.45a1,1,0,0,0-1,.85v7.9a1,1,0,0,0,1.92,0v-7.9A1,1,0,0,0,20,9.45Z"
});

var SvgIconEnable = function SvgIconEnable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return _ref2;
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEnable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-enable.ef1b47a2.svg";
export { ForwardRef as ReactComponent };